/* etempa feb 2024 */
if (!customElements.get('delayed-delivery-options')) {
    customElements.define('delayed-delivery-options', class DelayedDeliveryOptions extends HTMLElement{
        constructor(){
            super();

            //settings
            let blockedDatesArray = JSON.parse(this.dataset.blockedDatesArray)
            this.blockedDatesArray = [];
            blockedDatesArray.forEach(date => {
                this.blockedDatesArray.push(date.trim())
            })
            // this.blockSaturday = this.dataset.blockSaturday;
            this.blockMonday = true;
            this.blockSaturday = false;
            this.blockSunday = this.dataset.blockSunday;
            let daysOfWeekDisabled = [];

            if(this.blockMonday){
                daysOfWeekDisabled.push(1)
            }

            if(this.blockSaturday){
                daysOfWeekDisabled.push(6)
            }
            if(this.blockSunday){
                daysOfWeekDisabled.push(0)
            }

            let tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);

            let minDate = tomorrow;

            this.currentHour = new Date().getHours();
            this.currentDay = new Date().getDay();

            if (this.currentHour >= 14 && this.currentDay === 5) {
                minDate.setDate(minDate.getDate() + 3);
            } else if (this.currentDay === 6) {
                minDate.setDate(minDate.getDate() + 2);
            } else if (this.currentDay === 0) {
                minDate.setDate(minDate.getDate() + 1);
            } else if (this.currentHour >= 14) {
                minDate.setDate(minDate.getDate() + 1);
            }

            this.datepickerOptions = {
                clearButton: true,
                daysOfWeekDisabled: daysOfWeekDisabled,
                datesDisabled: this.blockedDatesArray,
                weekStart: 1,
                minDate: minDate,
                format: 'dd/mm/yyyy'
            };

            //input
            this.inputGiftMessage = this.querySelector('[data-input-gift-message]');
            this.giftMessageContainer = this.inputGiftMessage.closest('.input-container');
            this.inputDatePicker = this.querySelector('[data-input-date-picker]');
            this.datePickerContainer = this.inputDatePicker.closest('.input-container');
            this.inputShowGiftMessage = this.querySelector('[data-show-gift-message]');
            this.inputHideGiftMessage = this.querySelector('[data-hide-gift-message]');
            this.inputShowDatePicker = this.querySelector('[data-show-date-picker]');
            this.inputHideDatePicker = this.querySelector('[data-hide-date-picker]');
            this.allButtons = this.querySelectorAll('.btn');

            this.hasDateSelectedPreviously = this.inputDatePicker.hasAttribute('data-has-date-selected');
            //output
            this.form = null;
            this.formGiftMessageElement = null;
            this.formDatePickerElement = null;

            this.inputGiftMessage.addEventListener('keyup', this.handleGiftMessageInput.bind(this));
            this.inputDatePicker.addEventListener('change', this.handleDatePickerChange.bind(this));

            this.allButtons.forEach(button => {
                button.addEventListener('click', e => {
                    let container = button.closest('.button-container');
                    let containerButtons = container.querySelectorAll('button');
                    containerButtons.forEach(b => b.classList.remove('active'));
                    button.classList.add('active');
                })
            })

            this.inputShowGiftMessage.addEventListener('click', e => {
                e.preventDefault();
                this.giftMessageContainer.classList.remove('hide')
            })

            this.inputHideGiftMessage.addEventListener('click', e => {
                e.preventDefault();
                this.giftMessageContainer.classList.add('hide')
            })

            this.inputShowDatePicker.addEventListener('click', e => {
                e.preventDefault();
                this.datePickerContainer .classList.remove('hide');
                if(!this.hasDateSelectedPreviously){
                    this.handleDatePickerChange();
                }
            })

            this.inputHideDatePicker.addEventListener('click', e => {
                e.preventDefault();
                this.datePickerContainer .classList.add('hide');
                this.deleteFormDatepicker();
            })
        }
        init(formElement){
            this.form = formElement;
            this.formGiftMessageElement = this.form.querySelector('textarea[name="properties[Gift Message]"');

            if(window.CHOSEN_DELAYED_DATE != undefined){
                this.hasDateSelectedPreviously = true;
                this.inputDatePicker.setAttribute('data-has-date-selected', true)
                this.inputDatePicker.setAttribute('disabled', true);
                this.initDatePicker.value = window.CHOSEN_DELAYED_DATE;
            }

            if(!this.hasDateSelectedPreviously){
                this.initDatePicker();
            }
        }

        initDatePicker(){
            this.datepicker = new Datepicker(this.inputDatePicker, this.datepickerOptions)
            this.inputDatePicker.addEventListener('changeDate', this.handleDatePickerChange.bind(this))
        }

        handleGiftMessageInput(e){
            let value = this.inputGiftMessage.value;
            if(this.formGiftMessageElement != null){
                this.formGiftMessageElement.value = value;
            }
        }

        handleDatePickerChange(){
            let value = this.inputDatePicker.value.trim();
            if(value != ''){
                this.createFormDatePicker();
                this.formDatePickerElement.value = value;
                window.CHOSEN_DELAYED_DATE = value;
            }
            else{
                this.deleteFormDatepicker();
            }
        }

        deleteFormDatepicker(){
            if(this.formDatePickerElement != null){
                this.formDatePickerElement.remove();
                this.formDatePickerElement = null;
            }
        }

        createFormDatePicker(){
            if(this.formDatePickerElement == null){
                this.formDatePickerElement = document.createElement('input');
                this.formDatePickerElement.setAttribute('type', 'hidden');
                this.formDatePickerElement.setAttribute('name', 'properties[Delivery Date]');
                this.form.append(this.formDatePickerElement);
            }
        }
    });
}
  

/*
    a11y tooltips
*/

document.addEventListener('DOMContentLoaded', () => {
    const tooltipButtons = document.querySelectorAll('.tooltip-button');

    tooltipButtons.forEach(button => {
        let tooltipText = button.parentNode.querySelector('.tooltip-text');
        button.addEventListener('mouseenter', e => {
            showTooltip(tooltipText);
        })
        button.addEventListener('focus', () => {
            showTooltip(tooltipText);
        });

        button.addEventListener('mouseleave', () => {
            hideTooltip(tooltipText);
        });
        button.addEventListener('blur', () => {
            hideTooltip(tooltipText);
        });
        
        // hide the tooltip on escape key press
        button.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                hideTooltip(tooltipText);
            }
        });
    })

    function hideTooltip(tooltip) {
        tooltip.classList.remove('tooltip-shown')
        tooltip.setAttribute('aria-hidden', 'true');
    }

    function showTooltip(tooltip) {
        tooltip.classList.add('tooltip-shown')
        tooltip.removeAttribute('aria-hidden');
    }
})